module.exports = __webpack_public_path__ + "static/img/168Market.ed05916.png";


//////////////////
// WEBPACK FOOTER
// ./static/portal/168Market.png
// module id = 89
// module chunks = 18